<template>
  <v-app style="padding: 0; margin: 0;">
    <v-content style="padding: 0; margin: 0;">
      <v-container fluid class="d-flex" style="height: 100vh; padding: 0;">
        <v-row no-gutters class="w-100" style="height: 100%; margin: 0;">
          <!-- Columna Izquierda -->
          <v-col cols="5" class="d-flex align-center justify-center" style="padding: 0; height: 100%;">
            <div class="d-flex flex-column" style="max-width: 400px; margin: 0 auto;">
              <h1 class="text-h4 mb-4">{{$t('login.titulo')}}</h1>
              <p class="mb-4">{{$t('login.subtitulo')}}</p>
              <v-form @submit.prevent="login" class="d-flex flex-column">
                <v-text-field
                  variant="outlined"
                  v-model="email"
                  :label="$t('login.usuario')"
                  required
                ></v-text-field>

                <v-text-field
                  variant="outlined"
                  v-model="password"
                  :label="$t('login.password')"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  append-icon="mdi-eye"
                  @click:append="togglePasswordVisibility"
                ></v-text-field>

                <v-btn
                  color="primary"
                  class="mt-4"
                  type="submit"
                >
                  {{$t('login.boton_entrar')}}
                </v-btn>
                <ComponenteIdioma />
                <v-divider class="my-4"></v-divider>
                <v-row>
                  <v-col cols=6 class="d-flex justify-center">
                    <v-img
                      :src="require('../assets/simulart.svg')" 
                      alt="Simulart"
                      max-width="150"
                    ></v-img>
                  </v-col>
                  <v-col cols=6 class="d-flex justify-center">
                    <v-img v-if="nombre_app === 'ralph'"
                      :src="require('../assets/logo-enagas-renovables.png')" 
                      alt="Enagás Renovables"
                      max-width="150"
                    ></v-img>      
                  </v-col>          
                </v-row>
              </v-form>
            </div>
          </v-col>

          <!-- Columna Derecha -->
          <v-col cols="7" class="d-flex align-center justify-center" style="padding: 0; margin: 0; height: 100%;">
          
            
              <ComponenteAnimacionLogin 
              v-if="nombre_app === 'ralph'"
              class="w-100 h-100" style="margin: 0; padding: 0;" />
              
              <ComponenteAnimacionLoginOphelia 
              v-if="nombre_app === 'ophelia'"
              class="w-100 h-100" style="margin: 0; padding: 0;" />
          



          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>





<script>
//import axios from 'axios';
import { mapGetters } from 'vuex';
//import axios from '@/axios';
import ComponenteIdioma from './ComponenteIdioma.vue';
import ComponenteAnimacionLogin from './ComponenteAnimacionLogin.vue';
import ComponenteAnimacionLoginOphelia from './ComponenteAnimacionLoginOphelia.vue';
import axios from 'axios';
//import store from '../store';

export default {
name: 'PaginaLogin',
components: {
       ComponenteIdioma,
       ComponenteAnimacionLogin,
       ComponenteAnimacionLoginOphelia,
      },

    data() {
        return {   
            email: '',
            password: '',
            showPassword: false,    
            nombre_app: "",
        };
      },

    created() {
        // Cargar configuración proporcionada desde `main.js`
        fetch('/config.json')
          .then((response) => response.json())
          .then((config) => {
            this.nombre_app = config.nombre_app;  
                     
          })
          .catch((error) => {
            console.error('Error al cargar la configuración:', error);
            
          });
      },      

    mounted() {
        //const globalProps = this.$appContext.config.globalProperties;
        // Acceder a las globalProperties
        console.log("aqui")
        
    },

    computed: {
    ...mapGetters(['getMiVariableGlobal'])
    },


    methods: {

        togglePasswordVisibility() {
          this.showPassword = !this.showPassword; // Alterna entre mostrar y ocultar
        },

        login(){

            // De monento entramos sin hacer login            
            //this.$store.dispatch('actualizarUsuarioAutenticado', true);
            //this.$store.dispatch('actualizarToken', "TOKENxxxxxxxxxxxxxxx");                    
            //this.$store.dispatch('actualizarUsuarioNombre', "Nombre usuario");                    
            //this.$router.push('/');            



            
            axios(
                {
                    method: 'get',
                    url: process.env.VUE_APP_API_BASE_URL + '/api/login',
                    auth: {
                        username: this.email,
                        password: encodeURIComponent(this.password),
                      },
                    headers: {
                      'Content-Type': 'application/json; charset=utf-8',
                    },                      
                }
              )
              .then((response) => {    

                console.log(JSON.stringify(response.data))

                if (response.data.resultado != "ok"){

                    console.log("ERROR")
                    this.$swal(response.data.resultado);
  
                }else{
  
                    console.log("Estas validado!")                                        
                    this.$store.dispatch('actualizarUsuarioAutenticado', true);
                    this.$store.dispatch('actualizarToken', response.data.token);                    
                    this.$store.dispatch('actualizarUsuarioNombre', this.email);
                    this.$store.dispatch('actualizarCompany', response.data.company);
                    //console.log("response.data.company-> ", response.data.company)
                    console.log("A la página de home...")

                    this.$router.push('/');
              
                }  
                  
              })
              

            
        }

    }      
}


</script>